// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"79a08ec4","488":"cacb4055","495":"2b7531f2","769":"cb051622"}[chunkId] + ".chunk.js";
};